import client from "./client";
import type { TeamOption, Teammate, TeammateConversation, TeammateInput } from "../types/teammates";

export const teammatesApi = {
  list: () => client.get<Teammate[]>("/teammates"),
  listTeams: () => client.get<TeamOption[]>("/teammates/teams"),
  create: (data: TeammateInput) => client.post<Teammate>("/teammates", data),
  update: (id: string, data: TeammateInput) => client.put<Teammate>(`/teammates/${id}`, data),
  remove: (id: string) => client.delete(`/teammates/${id}`),
  listConversations: (id: string) => client.get<TeammateConversation[]>(`/teammates/${id}/conversations`),
  join: (id: string) => client.post(`/teammates/${id}/members`),
  leave: (id: string) => client.delete(`/teammates/${id}/members`),
};
